
import { defineComponent, ref, watch } from 'vue';
import DatePicker from '@/components/DatePicker.vue';

export default defineComponent({
    components: {
        DatePicker,
    },

    props: {
        modelValue: {
            type: Number,
            required: true,
        },
    },

    emits: {
        "update:modelValue": (payload: number) => typeof payload === "number",
    },

    setup(props, {emit})
    {
        // Convert the internal date value into an unix timestamp for the external value
        const dateValue = ref(new Date(props.modelValue * 1000));

        watch(dateValue, (newValue) => {
            emit("update:modelValue", newValue.getTime() / 1000);
        });

        return { dateValue };
    },
})
